import { render } from "./SecurityQuestionPage.vue?vue&type=template&id=21549690&scoped=true"
import script from "./SecurityQuestionPage.vue?vue&type=script&lang=js"
export * from "./SecurityQuestionPage.vue?vue&type=script&lang=js"

import "./SecurityQuestionPage.vue?vue&type=style&index=0&id=21549690&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21549690"]])

export default __exports__